<div mat-dialog-title>
  Other apps for {{ (authenticationService.organisation$ | async)?.display_name }}
</div>
<div mat-dialog-content>
  <mat-action-list>
    <ng-container *ngFor="let option of (authenticationService.organisation$ | async).domains">
      <div class="mat-list-item" *ngIf="!['api', 'webapp'].includes(option.type.name)"
           [class.disabled]="!isModuleActive(option)"
           [matTooltip]="isModuleActive(option) ? '' : 'Module is not active for this organisation!'">
        <div class="list-item">
          <div>
            <a href="{{ getOptionUrl(option.url, option.type.name) }}" target="_blank">
              <span class="type">{{ option.type.display_name }}</span>
              <span class="url">{{ option.url }}</span>
            </a>
            <ng-container *ngIf="['track-and-trace', 'survey'].includes(option.type.name)">
              <div fxLayout="row">
                <mat-form-field>
                  <mat-label>Selecteer meldingen</mat-label>
                  <mat-select [formControl]="form.controls[option.type.name]?.controls?.report_type">
                    <mat-option value="last">Laatste</mat-option>
                    <mat-option value="random">Willekeurig</mat-option>
                    <mat-option value="select">Selecteer</mat-option>
                  </mat-select>
                </mat-form-field>
                <mat-form-field class="report-number" *ngIf="form.controls[option.type.name]?.controls?.report_type?.value === 'select'">
                  <mat-label>Meldingen nummer</mat-label>
                  <input (click)="$event.stopImmediatePropagation()" [formControl]="form.controls[option.type.name]?.controls?.report_number"
                         [matAutocomplete]="reportNumber" matInput placeholder="Meldingen nummer">
                  <mat-autocomplete #reportNumber="matAutocomplete" [displayWith]="formatReportNumberDropdown">
                    <mat-option *ngFor="let option of suggestReportNumbers" [value]="option">
                      {{ option.created_at | date:'dd-MM-yy HH:mm' }} |
                      {{ option.number }}
                    </mat-option>
                  </mat-autocomplete>
                  <div matPrefix>
                    <span>{{ reportNumberAbbreviation }}</span>
                    <mat-select [formControl]="yearSelection" style="width:35px;">
                      <mat-option *ngFor="let year of years" [value]="year">{{ year }}</mat-option>
                    </mat-select>
                    <span>-</span>
                  </div>
                  <mat-spinner *ngIf="filters.reportNumbers.isLoading" diameter="20"></mat-spinner>
                </mat-form-field>
              </div>
            </ng-container>
          </div>
          <a href="{{ getOptionUrl(option.url, option.type.name) }}" target="_blank">
            <mat-icon>open_in_new</mat-icon>
          </a>
        </div>
        <fury-loading-overlay [isLoading]="form.controls[option.type.name]?.controls?.isLoading?.value" [fill]="true"></fury-loading-overlay>
      </div>
    </ng-container>
  </mat-action-list>
</div>
<mat-dialog-actions>
  <button [mat-dialog-close]="false" color="accent" mat-raised-button>ANNULEREN</button>
</mat-dialog-actions>
